module.exports = __webpack_public_path__ + "img/x17.87ec59a2.jpg";